// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TwitterSquareFilledSvg from "@ant-design/icons-svg/es/asn/TwitterSquareFilled";
import AntdIcon from '../components/AntdIcon';

var TwitterSquareFilled = function TwitterSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TwitterSquareFilledSvg
  }));
};

TwitterSquareFilled.displayName = 'TwitterSquareFilled';
export default React.forwardRef(TwitterSquareFilled);